module.exports = __webpack_public_path__ + "static/media/Peel Logo.9a388825.png";